// extracted by mini-css-extract-plugin
module.exports = {"FeaturedCta":"az_LMb","Compact":"az_MMb","Text":"az_NMb"};